export default "__VITE_ASSET__CTQ7Y$QB__"